const QUANTITY_INPUT_PREFIX = "qty-input";

export const QTY_INPUT_TEST_IDS = {
    INPUT: `${QUANTITY_INPUT_PREFIX}_input_field`,
    DELETE: `${QUANTITY_INPUT_PREFIX}_delete_icon`,
};
